import { render } from "./ActivateUser.vue?vue&type=template&id=17c476f0&scoped=true"
import script from "./ActivateUser.vue?vue&type=script&lang=js"
export * from "./ActivateUser.vue?vue&type=script&lang=js"

import "./ActivateUser.vue?vue&type=style&index=0&id=17c476f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c476f0"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCardSection,QIcon,QForm,QBtn,QBanner});
